export type PromotionEvents = {
    'General.Promotion.ActivateCounter': CounterData;
    'General.Promotion.DeactivateCounter': void;
    'General.Promotion.ShowCounter': void;
    'General.Promotion.HideCounter': void;
    'General.Promotion.UpdateCounter': CounterData;
    'General.Promotion.Started': void;
    'General.Promotion.Ended': void;
    'General.Promotion.Campaign.Ended': void;
    'GameSessionPromotion.START_STATE_LEFT': void;
    'MultiSetsMulticampaignPromotion.START_STATE_LEFT': void;
    'MultiSetsPromotion.START_STATE_LEFT': void;
};

export type CounterData = {
    left: number;
    total?: number;
    bet?: number;
    price?: number;
    id?: string;
    type?: string;
    valuedAtEnabled?: boolean;
};